import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { LegalDocument } from "./LegalDocument";
import { parseLegalDoc } from "./legalMarkdown";
import { termosEnterprise } from "./content/termosEnterprise";
import { termosEnterpriseV3 } from "./content/termosEnterpriseV3";
import { termosEnterpriseV1_3 } from "./content/termosEnterpriseV1_3";
import { termosEnterpriseV1_4 } from "./content/termosEnterpriseV1_4";

/**
 * Earlier published texts, kept verbatim and served at /termos?versao=<label>.
 * `2026-10-v3` is the text that published the Pix Automatico conditions v3
 * (Terms of Use 1.2); `1.3` and `1.4` retain the later replaced texts.
 */
const ARCHIVED_TERMS: ReadonlyMap<string, { text: string; shortTitle: string }> = new Map([
  ["2026-10-v3", { text: termosEnterpriseV3, shortTitle: "Termos de Uso (v3)" }],
  ["1.3", { text: termosEnterpriseV1_3, shortTitle: "Termos de Uso (v1.3)" }],
  ["1.4", { text: termosEnterpriseV1_4, shortTitle: "Termos de Uso (v1.4)" }],
]);

export const TermsPage: React.FC = () => {
  const [params] = useSearchParams();
  const requested = params.get("versao");
  const archived = requested !== null ? ARCHIVED_TERMS.get(requested) : undefined;
  const version = archived && requested !== null ? requested : null;
  const doc = React.useMemo(
    () => parseLegalDoc(archived ? archived.text : termosEnterprise),
    [archived],
  );
  return (
    <LegalDocument
      key={version ?? "current"}
      doc={doc}
      shortTitle={archived ? archived.shortTitle : "Termos de Uso"}
      icon={<ArticleOutlinedIcon />}
      testId="terms-page"
      versionNotice={
        version ? (
          <>
            Você está consultando os termos da versão {version}.{" "}
            <Link className="legalDoc-link" to="/termos">
              Ver termos atuais
            </Link>
          </>
        ) : undefined
      }
    />
  );
};

export default TermsPage;
